import Auth from "@/api/Auth";
import { ElMessage } from "element-plus";
import vimConfig from "@/config/VimConfig";
import AccountApi from "@/api/AccountApi";

/**
 * 请求类，支持无感刷新token
 * @author 乐天
 */
class FetchRequest {
  isRefreshing: boolean;
  private static instance: FetchRequest;

  private constructor() {
    this.isRefreshing = false;
  }

  /**
   * 单例构造方法，构造一个广为人知的接口，供用户对该类进行实例化
   * @returns {FetchRequest}
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new FetchRequest();
    }
    return this.instance;
  }

  /**
   * 请求方法
   * @param url 请求路径
   * @param params 参数
   * @param method 方法
   * @param isNeedToken 是否需要token
   */
  request = async (
    url: string,
    params: string,
    method: string,
    isNeedToken = false,
    isBlob = false
  ) => {
    const header: HeadersInit = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const token = Auth.getToken();
    if (isNeedToken && token) {
      header.Authorization = "Bearer " + token;
    }

    const config: RequestInit = {
      method: method,
      mode: "cors",
      headers: header,
    };

    if (method !== "GET") {
      config.body = params;
    }
    
    // return    fetch(this.getHost() + url, config).then( (response) => {
    //   console.log(response)
    //   if(isBlob){
    //     return response;
    //   }

    //   // return    this.check(response, url, params, method, isNeedToken, isBlob);
    // });
    try {
      const response = await  fetch(this.getHost() + url, config).then( (response) => {
          console.log(response)
          if(isBlob){
            return response;
          }
          return response
        //   // return    this.check(response, url, params, method, isNeedToken, isBlob);
        });
        const users = await response.json();
        console.log(users)
        if (users.code === 401) {
          return await this.getRetoken(url,params,method,isNeedToken,isBlob)
        } else if(users.code === 0){
            // console.log('=========0')
            console.log(users)
            return await Promise.resolve(users);
        }else{
            // console.log('========= 401')
            // console.log(res.msg)
            ElMessage.error(users.msg);
            return Promise.reject(users);
        }
    }catch(err){
      console.log(err)
    }
  };

  /**
   * 检查请求返回值，如果token失效,执行刷新方法
   * @param response 请求响应数据
   */
  // check =   (response: Response,url:string,params:string,method:string,isNeedToken:boolean,isBlob:boolean) => {
  //   //token 失效
  //   console.log(response)
  //   if (response.status === 200) {
  //     return response
  //       .json()
  //       .then(async (res) => {
  //         console.log(res)
  //         if (res.code === 401) {
  //           // console.log('========= 401')
  //             await this.getRetoken(url,params,method,isNeedToken,isBlob)
              
  //         }  else if(res.code === 0){
  //           // console.log('=========0')
  //           return Promise.resolve(res);
  //         }else{
  //           // console.log('========= 401')
  //           // console.log(res.msg)
  //           ElMessage.error(res.msg);
  //           return Promise.reject(res);
  //         } 
  //         // if (res.code === 401) {
  //         //   this.getRetoken(response)
  //         // } else if (res.code !== 200) {
  //         //   ElMessage.error(res.msg);
  //         //   return Promise.reject(res);
  //         // } else {
  //         //   return Promise.resolve(res);
  //         // }
  //       })
  //       .catch((err) => {
  //         console.log('========='+err)
  //         return Promise.reject(err);
  //       });
  //   }
   
  //   else {
  //     ElMessage.error("请求出错，状态码：" + response.status);
  //     return Promise.reject("请求出错");
  //   }
  // };

  getHost = (): string => {
    if (window.location.origin.indexOf("ai.123vp.com") > -1) {
      return 'https://api-human.123vp.com' 
    } else{
    //   return 'http' + "://" + Auth.getIp() + ":" + vimConfig.httPort
     return 'http://47.95.31.92:3456' 
    }
  };
  // 刷新token
  getRetoken = async (url:string,params:string,method:string,isNeedToken:boolean,isBlob:boolean)=>{
    const formDatas = new FormData();
    formDatas.append('refreshToken', Auth.getRefreshToken());
    let urls=''
    if (window.location.origin.indexOf("ai.123vp.com") > -1) {
      urls= 'https://api-human.123vp.com' 
    } else{
      urls= 'http://47.95.31.92:3456' 
    }
    await  fetch(urls+"/pc-api/digital-human/auth/refresh-token" ,
    {
      method: 'POST', 
      mode: 'cors', 
      body: formDatas,
    }).then( async res => {
      console.log('======== 刷新token================')
      return await  res.json()
    }).then(async res => {
      Auth.setToken(res.data.accessToken);
      Auth.setRefreshToken(res.data.refreshToken);
      return await this.request(url,params,method,isNeedToken,isBlob) 
    }).catch(err=>{
      return AccountApi.toLogin();
      })
  }
  // 有些 api 并不需要用户授权使用，则无需携带 access_token；默认不携带，需要传则设置第三个参数为 true
  get = (url: string, isNeedToken = false,isBlob = false) => {
    return this.request(url, "", "GET", isNeedToken,isBlob);
  };
 

  post = (url: string, params: string, isNeedToken = false) => {
    return this.request(url, params, "POST", isNeedToken);
  };

  put = (url: string, params: string, isNeedToken = false) => {
    return this.request(url, params, "PUT", isNeedToken);
  };

  del = (url: string, params: string, isNeedToken = false) => {
    return this.request(url, params, "DELETE", isNeedToken);
  };

  patch = (url: string, params: string, isNeedToken = false) => {
    return this.request(url, params, "PATCH", isNeedToken);
  };
}

export default FetchRequest.getInstance();
